import React from "react";
import PropTypes from "prop-types";
import ContributionEl from "./Contribution";
import Contribution from "../../models/Contribution";
import Thread from "./Thread";
import SourceEntity from "../Publications/models/SourceEntity";
import ClassificationModal from "../../pages/variant/components/ClassificationModal/ClassificationModal";
import isPortal from "../../common/helpers/isPortal";

function FlagContainer({ contribution, sourceEntity, userFlag }) {
  const flagId = String(userFlag?.id);
  const currentFlagId = String(contribution.id);
  const slug = sourceEntity.getSlugForContribution(contribution.id);
  const canEdit = flagId === currentFlagId && userFlag.id && contribution.id;
  const isClinical = isPortal();

  return (
    <div className="tw-pb-2 anim-fade-in anim-duration-400 font-helvetica">
      <div className="tw-p-2 tw-pt-2 tw-px-2 tw-relative tw-bg-blueGray-200 tw-rounded-lg">
        <ContributionEl contribution={contribution} />

        {canEdit && !isClinical ? (
          <ClassificationModal
            userFlag={userFlag}
            element={
              <div className="tw-absolute tw-top-0 tw-right-0 tw-px-2 hover:tw-underline tw-cursor-pointer">
                Edit
              </div>
            }
          />
        ) : null}
      </div>

      {isClinical ? null : (
        <Thread
          sourceEntity={sourceEntity}
          subType="classifications"
          subTypeId={String(contribution.id)}
          slug={slug}
          shouldAutoExpand={false}
          shouldHideExpandButton={false}
          shouldHideLines={false}
        />
      )}
    </div>
  );
}

FlagContainer.propTypes = {
  sourceEntity: PropTypes.instanceOf(SourceEntity),
  contribution: PropTypes.instanceOf(Contribution).isRequired,
  userFlag: PropTypes.shape({ id: PropTypes.number }),
};

FlagContainer.defaultProps = {
  sourceEntity: null,
  userFlag: {},
};

export default React.memo(FlagContainer);
